import DevOpsConnectionsStore from "./DevOpsConnections/DevOpsConnectionsStore";
import DevOpsSubscriptionsStore from "./DevOpsSubscriptions/DevOpsSubscriptionsStore";
import PipelinesBoardStore from "./PipelinesBoard/PipelinesBoardStore";
import BuildBoardStore from "./BuildBoard/BuildBoardStore";
import ReleasesStore from "./Releases/ReleasesStore";
import ReposStore from "./Repos/ReposStore";
import WorkItemsStore from "./WorkItems/WorkItemsStore";
import DevOpsScopeStore from "./shared/DevOpsScopeStore";
import DevOpsOverviewStore from "./DevOpsOverview/DevOpsOverviewStore";
import DevOpsLinkDialogStore from "./shared/DevOpsLinkDialogStore";
import DevOpsProjectStore from "./DevOpsProject/DevOpsProjectStore";

const devopsStoreList = [
  { name: "devopsConnectionsViewStore", store: DevOpsConnectionsStore },
  { name: "devopsSubscriptionsViewStore", store: DevOpsSubscriptionsStore },
  // One project's build definitions — Project 360's Pipelines tab.
  { name: "pipelinesBoardStore", store: PipelinesBoardStore },
  // The Pipelines page — every build across every project.
  { name: "buildBoardStore", store: BuildBoardStore },
  { name: "releasesStore", store: ReleasesStore },
  { name: "devopsReposViewStore", store: ReposStore },
  { name: "workItemsStore", store: WorkItemsStore },
  // THE one connection/project selection every board reads (2026-09-03).
  { name: "devopsScopeStore", store: DevOpsScopeStore },
  // The DevOps landing page (projects by client) and the shared link wizard.
  { name: "devopsOverviewViewStore", store: DevOpsOverviewStore },
  { name: "devopsLinkDialogStore", store: DevOpsLinkDialogStore },
  // Project 360 — one project, its clients/modules/links/webhooks, the boards as tabs.
  { name: "devopsProjectStore", store: DevOpsProjectStore },
];

export default devopsStoreList;
